import React from "react";
import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import useSnackbar from "../../../hooks/useSnackbar";
import { getTransactionDoBillingaddress } from "../../../api/transaction-type";

import { slugMap } from "../../../config/slug-config";
import { useParams } from "react-router-dom";
import { Box, Grid, CircularProgress, Link } from "@mui/material";

export default function BillCreditBilling({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);

  const pageDetail = slugMap[params.slug];

  const [rowData, setRowData] = useState([]);

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {
  //     setTableRefreshCount(prev => prev + 1);
  // }

  useEffect(() => {
    if (user.token && tabIndexP === 1) {
      getTransactionBillingAddressData();
    }
  }, [tabIndexP]);

  async function getTransactionBillingAddressData() {
    setLoading(true);
    try {
      const { data } = await getTransactionDoBillingaddress(user.token, {
        id: params.docNo,
      });
      setRowData(data.data.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      {loading ? (
        <>
          <Box className="viewDetilsBox">
            <Grid container className="mb-2">
              <Grid item xs={12}>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CircularProgress></CircularProgress>
                </div>
              </Grid>
            </Grid>
          </Box>
        </>
      ) : (
        <Box className="viewDetilsBox">
          {rowData.map((d, i) => (
            <>
              <Grid container className="mb-2">

                <Grid item xs={12} sm={6} md={6} className="m-b-10">
                  <p className="tFormlabel">VENDOR </p>
                  <p className="tFormName">{d.vendor}{" "}<span style={{ color: "#0066b2" }}>Map</span></p>
                  
                </Grid>
                
              </Grid>
            </>
          ))}
        </Box>
      )}
    </>
  );
}
